import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export interface DashboardStats {
  experiences: number;
  geniusLoci: number;
  events: number;
  artworks: number;
  trails: number;
  producers: number;
  localActivities: number;
}

export async function getDashboardStats(): Promise<DashboardStats> {
  try {
    console.log('📊 [DASHBOARD] Caricamento statistiche...');
    
    const [
      experiencesSnapshot,
      geniusLociSnapshot,
      eventsSnapshot,
      artworksSnapshot,
      trailsSnapshot,
      producersSnapshot,
      localActivitiesSnapshot
    ] = await Promise.all([
      getDocs(collection(db, 'experiences')),
      getDocs(collection(db, 'geniusLoci')),
      getDocs(collection(db, 'events')),
      getDocs(collection(db, 'artworks')),
      getDocs(collection(db, 'trails')),
      getDocs(collection(db, 'producers')),
      getDocs(collection(db, 'localActivities'))
    ]);

    const stats: DashboardStats = {
      experiences: experiencesSnapshot.size,
      geniusLoci: geniusLociSnapshot.size,
      events: eventsSnapshot.size,
      artworks: artworksSnapshot.size,
      trails: trailsSnapshot.size,
      producers: producersSnapshot.size,
      localActivities: localActivitiesSnapshot.size
    };

    console.log('📊 [DASHBOARD] Statistiche caricate:', stats);
    return stats;
  } catch (error) {
    console.error('❌ [DASHBOARD] Errore caricamento statistiche:', error);
    // Fallback con valori di default
    return {
      experiences: 0,
      geniusLoci: 0,
      events: 0,
      artworks: 0,
      trails: 0,
      producers: 0,
      localActivities: 0
    };
  }
}
